<template>
  <div class="right_box_main">
    <!-- 面包屑导航 -->
    <div class="mianbao">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/communityConsultation' }">智慧协商</el-breadcrumb-item>
        <el-breadcrumb-item>协商组织</el-breadcrumb-item>
        <el-breadcrumb-item>网格议事协商共治小组</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div
              id="chartss2"
              style="height:300px;width:100%;"
            ></div>
            <div class="fisthang">
              <el-form
                :inline="true"
                :model="searchlist"
                class="demo-form-inline"
                size="mini"
              >
                <el-form-item
                  label="组织名称:"
                  style="margin:0 30 0 0;"
                >
                  <el-input
                    v-model="searchlist.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="状态:"
                  style="margin:0 30 0 0;"
                >
                  <el-select
                    v-model="searchlist.auditStatus"
                    placeholder="--请选择--"
                    clearable
                    @change="personTypeChange"
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="searchlistdata"
                  >查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="info"
                    @click="searchlistReset"
                  >重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="three">
              <el-button
                type="primary"
                size="mini"
                @click="showDialogForm('','add')"
              >新增</el-button>
              <!-- <el-button type="danger" size="mini">导出Excel</el-button> -->
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
                current-row-key
                highlight-current-row
              >
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column
                  type="index"
                  align="center"
                  width="50"
                  label="序号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="name"
                  label="组织名称"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="communityName"
                  label="所属社区"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="creater"
                  label="创建人"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="contactInfo"
                  label="联系方式"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="auditStatus"
                  label="状态"
                  :formatter="formatterPersonType"
                ></el-table-column>
                <el-table-column
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="查看"
                      placement="top-start"
                    >
                      <button
                        style="color: #199b5d;"
                        class="iconfont icon-chakan tabBtn"
                        @click="showDialogForm(scope.row.id,'look')"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="修改"
                      placement="top-start"
                      v-if="scope.row.auditStatus != 1"
                    >
                      <button
                        style="color: #2e99cf;"
                        class="iconfont icon-bianji3 tabBtn"
                        @click="showDialogForm(scope.row.id,'edit')"
                      ></button>
                    </el-tooltip>
                    <!-- <el-tooltip
                      class="item"
                      effect="light"
                      content="审批"
                      placement="top-start"
                      v-if="scope.row.auditStatus == 0"
                    >
                      <button
                        style="color: #ff04ed;"
                        class="iconfont icon-shenhe tabBtn"
                        @click="showDialogForm(scope.row.id,'detail')"
                      ></button>
                    </el-tooltip> -->
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="删除"
                      placement="top-start"
                    >
                      <button
                        style="color: #dd3020;"
                        class="iconfont icon-icon7 tabBtn"
                        @click="showdeletepanduan(scope.row.id)"
                      ></button>
                    </el-tooltip>

                    <el-tooltip
                      class="item"
                      effect="light"
                      content="人员列表"
                      placement="top-start"
                    >
                      <button
                        style="color: #e400ff;"
                        class="iconfont el-icon-user-solid tabBtn"
                        @click="showDialogForm(scope.row.id,'person')"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageConfig.pageNo"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageConfig.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框新增/修改/查看 -->
    <el-dialog
      title="添加人员类别"
      :visible.sync="showadd"
      width="900px"
      :before-close="clearadddata"
    >
      <el-form
        :model="searchRylist"
        size="mini"
        label-width="100px"
      >
        <el-form-item label="组织名称:">
          <el-input
            v-model="searchRylist.name"
            placeholder="请输入姓名"
            style="width:60%"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属社区:">
          <el-cascader
            v-model="searchRylist.gridId"
            :options="orgList"
            @change="handleChange"
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="创建人:">
          <el-input
            v-model="searchRylist.creater"
            placeholder="请输入创建人"
            style="width:60%"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式:">
          <el-input
            v-model="searchRylist.contactInfo"
            placeholder="请输入联系方式"
            style="width:60%"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="审核:"
          v-if="showaudit"
        >
          <el-radio-group v-model="auditStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="审核意见:"
          v-if="showaudit"
        >
          <el-input
            v-model="auditOpinion"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="addPerson"
          v-if="showDisabled"
        >保存</el-button>
        <el-button
          type="info"
          size="small"
          @click="showadd = false"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { addPersonList, deletePerson } from "@/api/api"
import { log } from "util"
import echarts_msg from "../../../utils/echarts.js"
import request from "../../../utils/request.js"
import { getTypeById_p, getConsulTYpePersion } from "@/api/http.js"
import upimg from "@/components/uploadImg/index.vue"
let token = JSON.parse(window.localStorage.getItem("user"))
import { quillEditor } from "vue-quill-editor"
import editor_option from "@/utils/editorOption.js"
import G6 from "@antv/g6"
import { post } from "@/api/requrestHttp.js"
import { tabdata } from "@/mixins/tabledataMix.js"
export default {
  mixins: [tabdata],
  data() {
    return {
      auditStatus: 1,
      searchRylist: {},
      orgList: [],
      ids: [],
      personListData: [],
      searchRylist: {},
      searchGroups: [],
      searchGroupsChild: [],
      // 富文本配置
      editorOption: editor_option.editorOption,
      dialogTitle: "新增",
      // 新增弹出层
      showadd: false,
      showDisabled: false,
      addform: {
        photoPath: "",
        photoPath: "",
        parentPersonTypeId: "", //人员大类类别
        personTypeId: "", // 人员小类类别
        consultType: "",
        name: "",
        sex: "",
        numberId: "",
        phone: "",
        resume: "",
        enclosure: "",
        status: "",
      },
      statusList: [
        {
          value: "0",
          label: "未审核",
        },
        {
          value: "1",
          label: "通过",
        },
        {
          value: "2",
          label: "不通过",
        },
      ],
      rules: {
        parentPersonTypeId: [
          {
            required: true,
            message: "请选择上级类别",
            trigger: "change",
          },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        numberId: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0,
            message: "必须为数字值",
            trigger: "blur",
          },
        ],
        // major: [
        //     { required: true, message: "请选择专业", trigger: "blur" }
        // ],
        resume: [
          {
            required: true,
            message: "请输入人员简历",
            trigger: "blur",
          },
          {
            max: 300,
            message: "输入字符长度少于300字符",
            trigger: "blur",
          },
        ],
        photoPath: [{ required: true, message: "请上传照片", trigger: "blur" }],
        status: [
          {
            required: true,
            message: "请选择启动状态",
            trigger: "change",
          },
        ],
      },
      //弹出框审核
      showaudit: false,

      //专业
      searchTypes: [],
      //人员类别
      searchGroups: [],
      searchGroupsChild: [],
      //维护时需转换的字段
      fileList: [],
      majors: [],
      //表格数据

      readyOnly: false,
      showType: "",
      uploadUrl: request.defaults.baseURL + "/consulType/info/uplodfile",
      uploadMoreUrl: request.defaults.baseURL + "/consulType/info/uplodfiles",
    }
  },
  created() {
    post("/rbac/admin/org/info/OrgTreelist", { orgType: 1, orgLevel: 2,isValid: 1, }).then(
      (res) => {
        this.orgList = res.content
      }
    )
    this.initTableDataUrl("/admin/consulOrg/info/listConsultOrg")
  },
  methods: {
    handleChange(val) {
      this.searchRylist.gridId = val[val.length - 1]
    },
    addPerson() {
      let url = ""
      if (this.showType == "add") {
        url = "/admin/consulOrg/info/insertConsultOrg"
        post(url, {
          ...this.searchRylist,
          auditStatus: 0,
          createOrgLevel: 4,
        }).then((res) => {
          this.showadd = false
          this.$message.success(res.message)
          this.getPageDatas()
        })
      } else if (this.showType == "edit") {
        url = "/admin/consulOrg/info/updateConsultOrg"
        post(url, {
          auditStatus: 0,
          ...this.searchRylist,
        }).then((res) => {
          this.showadd = false
          this.$message.success(res.message)
          this.getPageDatas()
        })
      } else {
        post("/admin/consulOrg/info/auditConsultOrg", {
          id: this.searchRylist.id,
          auditStatus: this.auditStatus,
        }).then((res) => {
          this.showadd = false
          this.$message.success(res.message)
          this.getPageDatas()
        })
      }
    },
    selectionChange(val) {
      //console.log("select",val);
      let ids = []
      if (val) {
        val.forEach((element) => {
          ids.push(element.id)
        })
        this.ids = ids
        //console.log(ids)
      }
    },

    //获取人员类别树状图
    async getPTypes() {
      var res = await getTypeById_p({
        pageNo: 1,
        pageSize: 9999,
        // parentId: 0
      })
      //   console.log(res);
      if (res.content) {
        this.searchGroups = res.content.list || []
      }
    },

    //人员类别改变状态
    async personTypeChange(ids) {
      let res = await getTypeById_p({
        parentId: ids,
        pageSize: 9999,
        pageNo: 1,
      })
      if (res.content) {
        this.searchGroupsChild = res.content.list || []
      }
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },

    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },

    //改变状态
    async changeStatus(cdata) {
      let fd = new FormData()
      fd.append("token", token)
      let params = JSON.stringify(cdata)
      if (params != "{}") {
        fd.append("ConsultPerson", params)
      }

      var res = await request({
        url: "/admin/consulType/info/insertConsultPerson",
        method: "POST",
        data: fd,
      })

      // console.log(res)
      var msg = "状态"
      msg = msg + (cdata.status == "0" ? "启用" : "禁用")
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success",
        })
      } else {
        console.log(res.message)
        this.$message({
          message: msg + "失败",
          type: "error",
        })
      }
    },
    //改变状态
    async personTypeChange(ids) {
      let res = await getTypeById_p({
        parentId: ids,
        pageSize: 9999,
        pageNo: 1,
      })
      if (res.content) {
        this.searchGroupsChild = res.content.list || []
      }
    },
    async showDialogForm(id, flag) {
      //编辑
      this.showType = flag
      if (id != "") {
        if (flag == "edit") {
          this.dialogTitle = "编辑"
          this.showadd = true
          this.readyOnly = false
          this.showaudit = false
          this.showDisabled = true
        } else if (flag == "look") {
          this.dialogTitle = "查看"
          this.showDisabled = false
          this.showaudit = false
          this.showadd = true
          this.readyOnly = true
        } else if (flag == "detail") {
          this.dialogTitle = "审批"
          this.showDisabled = true
          this.showaudit = true
          this.showadd = true
          this.readyOnly = false
        } else if (flag == "person") {
          this.$router.push({ path: "communityWgPerson", query: { id: id } })
        }
        //获取编辑项的最新数据
        let data = {}
        data.id = id
        post("/admin/consulOrg/info/getConsultOrg", data).then((res) => {
          this.searchRylist = res.content
          this.searchRylist.gridId = res.content.gridId + ""
        })
      } else {
        this.showDisabled = true
        this.showaudit = false
        this.readyOnly = false
        this.showadd = true
        this.dialogTitle = "新增"
        // console.log(this.$refs.addform);
      }
    },
    handleExceed(files, fileList) {
      var selected = files.length
      var totalselected = selected + fileList.length
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      )
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isLt2M
    },
    uploadSuccess(response, file, fileList) {
      // console.log(response)
      if (
        response.code == 200 &&
        response.content != "" &&
        response.content != null
      ) {
        this.addform.photoName = response.content.name
        this.addform.photoPath = response.content.path
      }
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccessMore(response, file, fileList) {
      if (
        response.code == 200 &&
        response.content != "" &&
        response.content != null
      ) {
        this.fileList.push({
          name: response.content.name,
          url: response.content.path,
        })
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url)
    },
    addformClick() {
      this.$refs.addform.validate((valid) => {
        if (valid) {
          this.saveadddata()
        } else {
          //   console.log("error submit!!");
          return false
        }
      })
    },
    //获取新增所有数据发请求
    async saveadddata() {
      let fd = new FormData()
      fd.append("token", token)
      //对多选的专业进行数组转字符串
      if (this.majors.length > 0) {
        this.addform.major = this.majors.join("/")
      }
      if (this.fileList.length > 0) {
        this.addform.enclosurePath = ""
        this.addform.enclosureName = ""
        this.fileList.forEach((item) => {
          this.addform.enclosurePath =
            this.addform.enclosurePath + "," + item.url
          this.addform.enclosureName =
            this.addform.enclosureName + "," + item.name
        })
      }
      let params = JSON.stringify(this.addform)
      if (params == "{}") {
        this.$message({
          message: "保存数据为空",
          type: "error",
        })
        return false
      }
      fd.append("ConsultPerson", params)
      console.log(params)
      var res = await request({
        url: "/admin/consulType/info/insertConsultPerson",
        method: "POST",
        data: fd,
      })
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success",
        })
        this.showadd = false
        this.pageConfig.pageNo = 1
        this.getPageDatas()
      } else {
        console.log(res)
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error",
        })
      }
    },
    //审批接口
    async saveAuditdata() {
      if (!this.addform.approvalStatus || !this.addform.approvalOpinion) {
        this.$message({
          message: "保存数据为空",
          type: "error",
        })
        return false
      }
      let fd = new FormData()
      fd.append("token", token)
      let params = JSON.stringify({
        id: this.addform.id,
        approvalStatus: this.addform.approvalStatus,
        approvalOpinion: this.addform.approvalOpinion,
      })
      fd.append("ConsultPerson", params)
      console.log(params)
      var res = await request({
        url: "/admin/consulType/info/approvalConsultPerson",
        method: "POST",
        data: fd,
      })
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success",
        })
        // this.showaudit = false;
        this.showadd = false
        this.pageConfig.pageNo = 1
        this.getPageDatas()
      } else {
        console.log(res)
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error",
        })
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false
    },
    //根据身份证号码截取出生年月
    fullBirthday() {
      if (this.addform.numberId != undefined) {
        let iden = this.addform.numberId
        let birth = ""
        if (iden.length === 18) {
          birth =
            iden.substring(6, 10) +
            "-" +
            iden.substring(10, 12) +
            "-" +
            iden.substring(12, 14)
        }
        if (iden.length === 15) {
          birth =
            "19" +
            iden.substring(6, 8) +
            "-" +
            iden.substring(8, 10) +
            "-" +
            iden.substring(10, 12)
        }
        this.$set(this.addform, "birthday", birth)
      }
    },

    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          post("/admin/consulOrg/info/deleteConsultOrg", {
            id: id,
          }).then((res) => {
            this.$message.success(res.message)
            this.getPageDatas()
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },

    //获取人员类别树状图
    async getPTypes() {
      var res = await getTypeById_p({
        pageNo: 1,
        pageSize: 9999,
        // parentId: 0
      })
      //   console.log(res);

      if (res.content) {
        this.searchGroups = res.content.list || []
      }
    },
    formatterPersonType(row, column) {
      let status = row.auditStatus
      let obj = {
        0: "未审核",
        1: "通过",
        2: "不通过",
      }
      return obj[status]
    },
  },
  mounted() {
    this.getPTypes()
    this.getPageDatas()

    let data = {
      id: "委员会主任",
      children: [
        {
          id: "两委成员",
          // children: [
          //   { id: "两委代表" },
          //   { id: "两新代表" },
          //   { id: "两代表一委员" },
          //   { id: "居民监督委员会代表" }
          // ]
        },
        {
          id: "村（居）务监督委员会",
        },
        {
          id: "村（居）民小组",
        },
        {
          id: "两代表一委员",
        },
        {
          id: "驻村(居)单位",
        },
        {
          id: "辖区社会组织",
        },
        {
          id: "农村集体经济组织",
        },
        // {
        //   id: "社区党委副书记",
        //   children: [
        //     { id: "业委会代表" },
        //     { id: "物业企业代表" },
        //     { id: "专业人士代表" },
        //     { id: "利益方" }
        //   ]
        // }
      ],
    }
    const width = document.getElementById("chartss2").scrollWidth
    const height = document.getElementById("chartss2").scrollHeight || 500
    const graph = new G6.TreeGraph({
      container: "chartss2",
      width,
      height,
      pixelRatio: 2,
      linkCenter: true,
      modes: {
        default: [
          {
            type: "collapse-expand",
            onChange: function onChange(item, collapsed) {
              const data = item.get("model").data
              data.collapsed = collapsed
              return true
            },
          },
        ],
      },
      defaultNode: {
        shape: "rect",
        size: [120, 30],
        anchorPoints: [
          [0.5, 0],
          [0.5, 1],
        ],
        style: {
          radius: 10,
          fill: "#C6E5FF",
          stroke: "#5B8FF9",
        },
      },
      defaultEdge: {
        shape: "polyline",
        sourceAnchor: 0.5, // 锚点索引
        targetAnchor: 1, // 锚点索引
        style: {
          radius: 10,
          endArrow: false,
          lineWidth: 1,
          stroke: "#C2C8D5",
        },
        labelCfg: {
          position: "end",
          style: {
            fill: "#595959",
          },
        },
      },
      layout: {
        type: "compactBox",
        direction: "TB",
        getId: function getId(d) {
          return d.id
        },
        getHeight: function getHeight() {
          return 16
        },
        getWidth: function getWidth() {
          return 52
        },
        getVGap: function getVGap() {
          return 22
        },
        getHGap: function getHGap() {
          return 40
        },
      },
    })
    graph.node(function (node) {
      return {
        label: node.id,
      }
    })

    graph.data(data)
    graph.render()
    graph.fitView()
  },

  components: {
    upimg,
    quillEditor,
  },
}
</script>

<style lang="less" scoped>
//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    width: 270px;
  }
  .card-r {
    // overflow: hidden;
    flex: 1;
    height: 320px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-0 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .card-2 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        // background-color: red;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .card-3 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }

    .topbarnav {
      display: flex;
      align-items: center;
      div {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
      }
    }
  }
}
.card-4 {
  margin-top: 12px;
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}

.download {
  .color {
    height: 25px;
    line-height: 25px;
    padding-left: 20px;
    background-color: #cdcdcd;
  }
  p {
    margin: 10px 0 10px 0;
    padding-left: 20px;
    a {
      color: #01aaef;
    }
  }
}
.threestyleimg {
  display: flex;
  // align-items: center;
  // justify-content: center;
  flex-wrap: wrap;
  .threestyleimgtu {
    width: 80%;
    height: 70%;
    margin-bottom: 20px;
    // background-color: red;
    display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .threestyleimgbtn {
    width: 80%;
    height: 30%;
    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
      width: 170px;
      height: 30%;
      background: #ffffff;
      border: 1px solid #cad4dc;
      text-align: center;
      line-height: 30px;
    }
    input {
      position: absolute;
      width: 172px;
      height: 32px;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>